import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-tabs-wrap" }
const _hoisted_2 = { class: "home-tabs" }

import {TabsBlock} from "@/entities";
import {TabServicesSolutions,TabTerminalSolutions,TabDocumentationConsulting} from "@/features";

export default /*#__PURE__*/_defineComponent({
  __name: 'home-tabs',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TabsBlock), null, {
        services_solutions: _withCtx(() => [
          _createVNode(_unref(TabServicesSolutions))
        ]),
        terminal_solutions: _withCtx(() => [
          _createVNode(_unref(TabTerminalSolutions))
        ]),
        documentation_consulting: _withCtx(() => [
          _createVNode(_unref(TabDocumentationConsulting))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})